// Quotes API endpoints (price quotes - a 5th "transaction" type that can
// later be continued into a real Cash Sale/Account Invoice, or discarded)

import apiClient from './client';

export const quotesAPI = {
  getAll: () => apiClient.get('/quotes'),
  getById: (id) => apiClient.get(`/quotes/${id}`),
  create: (data) => apiClient.post('/quotes', data),
  update: (id, data) => apiClient.patch(`/quotes/${id}`, data),
  delete: (id) => apiClient.delete(`/quotes/${id}`),
  downloadPDF: (id) => apiClient.get(`/quotes/${id}/pdf`, {
    responseType: 'blob'
  })
};
